import {html} from '../lib/lit-html.js';

export function searchPageLoadMore(state){
	if (state.search.totalPages < 2) return [];
	if (state.search.page === state.search.totalPages) return [];

	return html`
		<div class="ekm-search-page-pagination ekm-search-loadmore">
			<span class="ekm-search-page-pagination-loadmore-button">
				Load More
			</span>
		</div>
	`;
}